import {
    MonitoringPaginationEndpointService
} from "@/views/monitoring/shared/endpoint_services/monitoring-pagination-endpoint-service"
import { format } from "date-fns-tz"

export class MonitoringPaginationService {
    constructor () {
        this.monitoringPaginationEndpointService = new MonitoringPaginationEndpointService()
    }

    async getAdb (adbData) {
        const res = await this.monitoringPaginationEndpointService.getAdb(adbData)
        return res
    }

    async getMdb (mdbData) {
        const res = await this.monitoringPaginationEndpointService.getMdb(mdbData)
        return res
    }

    async getMonitoring (monitoringData) {
        const res = await this.monitoringPaginationEndpointService.getMonitoring(monitoringData)
        return res
    }

    // get offline points
    async getRecordForDashboard (pointData, tableOptions) {
        let points = null
        if (tableOptions !== undefined) {
            points = await this.monitoringPaginationEndpointService.getRecordForDashboard(pointData, tableOptions)
        } else {
            points = await this.monitoringPaginationEndpointService.getRecordForDashboard(pointData, {
                page: 1,
                itemsPerPage: 10
            })
        }
        return points
    }

    async getSkud (skudData) {
        const res = await this.monitoringPaginationEndpointService.getSkud(skudData)
        // console.log('getSkud res',res)
        // if (!res.skudLogs) {
        //     return res
        // }
        // const result = res.skudLogs.map(m => {
        //     m.last_sync_at = format(new Date(m.last_sync_at), "dd.MM.yyyy")
        //     return m
        // })
        return res
    }
}
